export const subscriptions = (() => {
    const subscriptionsCheckboxes = document.querySelectorAll(".subscriptions-toggle");

    Array.from(subscriptionsCheckboxes).forEach((cb) => addEL(cb));

    function addEL(cb) {
        if (!cb.hasAttribute("data-propertyId")) return;

        cb.addEventListener("change", function () {
            const id = cb.getAttribute("data-propertyId");
            const contactId = cb.getAttribute("data-contactId");
            const isChecked = cb.checked;
            const url = `/Property/ToggleProperty/?propertyID=${id}&IsActive=${isChecked}&contactId=${contactId}`;
            cb.setAttribute("disabled", "disabled");

            fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({}),
            })
                .then((response) => response.json())
                .then((data) => {
                    const success = data.success;
                    const isActive = data.isActive;
                    setStatus(cb, success, isActive, isChecked);
                })
                .catch((error) => {
                    console.error("Error:", error);
                    setStatus(cb, false, false, isChecked);
                });
        });
    }

    function setStatus(cb, success, state, wasChecked) {
        if (success) {
            cb.removeAttribute("disabled");
            cb.checked = state;
            cb.previousElementSibling.classList.add("subscriptions-textLabel-updated");

            setTimeout(() => {
                cb.previousElementSibling.classList.remove("subscriptions-textLabel-updated");
            }, "1000");
        } else {
            cb.removeAttribute("disabled");
            cb.checked = !wasChecked;
        }
    }
})();

export const importantCompanyConnections = (() => {
    const companyConnectionDropdown = document.querySelectorAll(".selectCompany-select:not(.js-negotiationRecipient)");

    Array.from(companyConnectionDropdown).forEach((ccd) => addEL(ccd));

    function addEL(ccd) {
        ccd.addEventListener("change", function () {

            const selectedOption = ccd.options[ccd.selectedIndex];
            const id = selectedOption.getAttribute("data-companyId");
            const contactId = selectedOption.getAttribute("data-contactId");
            const propName = selectedOption.getAttribute("data-propName");
            const url = `/Property/ToggleCompanyConnection/?companyId=${id}&propName=${propName}&contactId=${contactId}`; 
            ccd.setAttribute("disabled", "disabled");

            fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({}),
            })
                .then((response) => response.json())
                .then((data) => {
                    const success = data.success;
                    setStatus(ccd, success, true);
                })
                .catch((error) => {
                    console.error("Error:", error);
                    setStatus(ccd, false, false);
                });
        });
    }

    function setStatus(ccd, success, state) {
        if (success) {
            ccd.removeAttribute("disabled");
            //ccd.previousElementSibling.classList.add("subscriptions-textLabel-updated");

            setTimeout(() => {
                //ccd.previousElementSibling.classList.remove("subscriptions-textLabel-updated");
            }, "1000");
        } else {
            ccd.removeAttribute("disabled");
        }
    }
})();

export const negotiationRecipient = (() => {
    const select = document.querySelector(".js-negotiationRecipient");

    if (!select) return;

    let previousValue = select.value;

    select.addEventListener("change", () => {
        const selectedOption = select.options[select.selectedIndex];
        if (!select.value) return;

        const companyId = selectedOption.getAttribute("data-companyId");
        const contactId = selectedOption.getAttribute("data-contactId");
        const url = `/Property/SetNegotiationRecipient/?companyId=${companyId}&contactId=${contactId}`;
        select.setAttribute("disabled", "disabled");

        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({}),
        })
            .then((response) => response.json())
            .then((data) => data.success === true)
            .catch((error) => {
                console.error("Error:", error);
                return false;
            })
            .then((success) => {
                if (success) {
                    previousValue = select.value;
                    select.querySelector('option[value=""]')?.remove();
                } else {
                    select.value = previousValue;
                }
                select.removeAttribute("disabled");
            });
    });
})();
